"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHodPolygon = exports.getHodsByArea = exports.getHodsByAreaAndCharacters = void 0;
var tslib_1 = require("tslib");
var graphql_tag_1 = require("graphql-tag");
function getHodsByAreaAndCharacters(_a) {
    var areaId = _a.areaId, chars = _a.chars, hodsVersion = _a.hodsVersion, take = _a.take, skip = _a.skip;
    var where = {
        version: { equals: hodsVersion },
        Area: {
            is: {
                id: {
                    equals: areaId,
                },
            },
        },
    };
    where.OR = [{ nameAr: { contains: chars } }, { hodKey: { contains: chars } }];
    var variables = {
        where: where,
        take: take || 100,
        skip: skip,
    };
    return {
        query: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      query($where: HodWhereInput, $take: Int, $skip: Int) {\n        hods(where: $where, take: $take, skip: $skip) {\n          id\n          nameAr\n          nameEn\n          lat\n          lng\n          radius\n          zoom\n          hodKey\n          Area {\n            id\n            name\n          }\n          version\n        }\n      }\n    "], ["\n      query($where: HodWhereInput, $take: Int, $skip: Int) {\n        hods(where: $where, take: $take, skip: $skip) {\n          id\n          nameAr\n          nameEn\n          lat\n          lng\n          radius\n          zoom\n          hodKey\n          Area {\n            id\n            name\n          }\n          version\n        }\n      }\n    "]))),
        variables: variables,
    };
}
exports.getHodsByAreaAndCharacters = getHodsByAreaAndCharacters;
function getHodsByArea(_a) {
    var areaId = _a.areaId, HodsVersion = _a.HodsVersion, orderBy = _a.orderBy, take = _a.take, skip = _a.skip;
    return {
        variables: {
            where: {
                version: {
                    equals: HodsVersion,
                },
                Area: {
                    is: {
                        id: {
                            equals: areaId,
                        },
                    },
                },
            },
            orderBy: orderBy,
            take: take || 100,
            skip: skip,
        },
        query: (0, graphql_tag_1.default)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n      query(\n        $where: HodWhereInput!\n        $orderBy: [HodOrderByInput!]\n        $take: Int\n        $skip: Int\n      ) {\n        hods(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {\n          id\n          nameAr\n          lat\n          lng\n          radius\n          zoom\n          hodKey\n          Area {\n            id\n            name\n          }\n        }\n      }\n    "], ["\n      query(\n        $where: HodWhereInput!\n        $orderBy: [HodOrderByInput!]\n        $take: Int\n        $skip: Int\n      ) {\n        hods(where: $where, orderBy: $orderBy, take: $take, skip: $skip) {\n          id\n          nameAr\n          lat\n          lng\n          radius\n          zoom\n          hodKey\n          Area {\n            id\n            name\n          }\n        }\n      }\n    "]))),
    };
}
exports.getHodsByArea = getHodsByArea;
function getHodPolygon(_a) {
    var id = _a.id;
    var variables = {
        where: {
            id: {
                equals: id,
            },
        },
    };
    return {
        query: (0, graphql_tag_1.default)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n      query Hods($where: HodWhereInput) {\n        hods(where: $where) {\n          id\n          polygon\n        }\n      }\n    "], ["\n      query Hods($where: HodWhereInput) {\n        hods(where: $where) {\n          id\n          polygon\n        }\n      }\n    "]))),
        variables: variables,
    };
}
exports.getHodPolygon = getHodPolygon;
var templateObject_1, templateObject_2, templateObject_3;
